import i18n from '@i18n';
import en from './navigation-i18n/en';
import { FuseNavItemType } from '@fuse/core/FuseNavigation/types/FuseNavItemType';

i18n.addResourceBundle('en', 'navigation', en);

const navigationConfig: FuseNavItemType[] = [
  {
    id: 'dashboard-component',
    title: 'Dashboard',
    translate: 'DASHBOARD',
    type: 'item',
    icon: 'heroicons-outline:tv',
    url: '/dashboard',
  },
  {
    id: 'workflow-component',
    title: 'Workflows',
    translate: 'WORKFLOWS',
    type: 'item',
    icon: 'heroicons-outline:fire',
    url: '/workflows',
    subtitle: '',
  },
  // Order: the two everyday queues (Workflows, Approvals) stay next to each other at the top;
  // Connect and Agents are permission-gated and can disappear, so they come last in the section
  // and the visible core of the menu is the same for every user.
  {
    // id must be 'approvals-component' — ApprovalsNavBadgeSync updates the badge count here.
    id: 'approvals-component',
    title: 'Approvals',
    type: 'item',
    icon: 'heroicons-outline:check-badge',
    url: '/approvals',
  },
  {
    id: 'capture-component',
    title: 'Connect',
    translate: 'CAPTURE',
    type: 'item',
    icon: 'heroicons-outline:cpu-chip',
    url: '/connect',
  },
  {
    id: 'director-agents-component',
    title: 'Agents',
    type: 'item',
    icon: 'heroicons-outline:command-line',
    url: '/agents',
  },
  {
    id: 'applications-component',
    title: 'Apps',
    subtitle: 'Custom Applications',
    type: 'group',
    icon: 'heroicons-outline:cube',
    children: [],
  },
  {
    id: 'admin',
    title: 'Admin',
    subtitle: 'Site and user settings',
    type: 'group',
    icon: 'heroicons-outline:lock-closed',
    children: [
      {
        id: 'admin.activities',
        title: 'Activities',
        type: 'item',
        icon: 'heroicons-outline:bars-3-bottom-left',
        url: '/admin/activities',
      },
      {
        id: 'admin.workflows',
        title: 'Edit Workflows',
        type: 'item',
        icon: 'heroicons-outline:pencil-square',
        url: '/admin/workflows',
        meta: { requiredPermission: 'hasAddWorkflows' }, // super-admin OR users with Add/Edit Workflows permission
      },
      {
        id: 'admin.applications',
        title: 'Applications',
        type: 'item',
        icon: 'heroicons-outline:view-columns',
        url: '/admin/applications',
        meta: { requiredPermission: 'hasCreateApplications' }, // super-admin OR users with Create/Edit Applications permission
      },
      {
        id: 'admin.feedback',
        title: 'Feedback',
        type: 'item',
        icon: 'heroicons-outline:chat-bubble-left-right',
        url: '/admin/feedback',
        meta: { superOnly: true },
      },
      {
        id: 'admin.settings',
        title: 'Settings',
        type: 'item',
        icon: 'heroicons-outline:cog-8-tooth',
        url: '/admin/settings',
      //  meta: { superOnly: true }, // ⬅️ super-admin only
      },
    ],
  },
];

export default navigationConfig;
